import type { JobPostSearchRequest } from '@trukt/tms-api/JobService';
import { createKey } from '../../createKey';

const keyHandler = createKey('job-post');

export const JobPostServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<JobPostSearchRequest>(),
};
